module.exports = __webpack_public_path__ + "8bcb9041624fecab0eba22114a2143bb.pdf";